<template>
    <v-overlay v-model="shown" opacity="0" persistent />

    <v-snackbar v-model="shown" color="info" activator="#sf-TutorialButton" :target="target" location-strategy="connected"
        location="bottom" open-on-click :close-on-back="false" :close-on-content-click="false" timeout="-1"
        max-width="400" multi-line offset="10" transition="v-fade-transition">

        <div class="d-flex align-center">
            <v-icon class="me-5" size="40" :icon="icon"></v-icon>
            <p>{{ text }}</p>
        </div>

        <template v-slot:actions>
            <div class="d-flex flex-column align-end">
                <v-btn variant="text" @click="close" icon="mdi-close" />

                <div class="d-flex flex-row">
                    <v-btn variant="text" @click="back" icon="mdi-chevron-left" />
                    <v-btn variant="text" @click="next" icon="mdi-chevron-right" />
                </div>
            </div>

        </template>
    </v-snackbar>
</template>

<script>
import constants from '@/config/constants';

export default {
    name: 'TutorialTooltip',
    data() {
        return {
            shown: false,
            counter: 0,
        }
    },
    computed: {
        text() {
            return constants.tutorial[this.counter].text;
        },
        icon() {
            return constants.tutorial[this.counter].icon;
        },
        target() {
            return constants.tutorial[this.counter].targetElem;
        },
    },
    methods: {
        next() {
            if (constants.tutorial.length !== this.counter + 1)
                this.counter++;
        },
        back() {
            if (this.counter !== 0)
                this.counter--;
        },
        open() {
            this.shown = true;
        },
        close() {
            this.shown = false;
        },
    },
    watch: {
        shown() {

            if (this.shown) {

                //Send event to App to show the nav sidebar
                this.$emit('update:shown');

                document.querySelector(this.target).classList.add('sf-tutorial-highlight');

            } else {
                this.counter = 0

                for (let i = 0; i < constants.tutorial.length; i++) {
                    document.querySelector(constants.tutorial[i].targetElem).classList.remove('sf-tutorial-highlight');
                }
            }
        },
        counter(newVal, oldVal) {
            if (this.shown) {

                document.querySelector(constants.tutorial[oldVal].targetElem).classList.remove('sf-tutorial-highlight');
                document.querySelector(this.target).classList.add('sf-tutorial-highlight');
            }
        },
    },
};
</script>